/** @see DesignGraphQlSchema.type. */
export enum GraphQlSchemaType {
  schema = 'SCHEMA',
  url = 'URL'
}
